import React, { useState, useLayoutEffect } from "react";
import { StyleSheet, View } from "react-native";
import "../../../App.scss";
import Page1 from "./page1";
import Page2 from "./page2";
import Page4 from "./page4";
import Page5 from "./dragComponent/index";
import ModuleTop from "../../../Components/Layout/Default/module-top";
export default function Index(props) {
  const [display, setDisplay] = useState(false);
  const [pageFirst, setPageFirst] = useState(true);
  const [pageSecond, setPageSecond] = useState(true);
  const [pageThird, setPageThird] = useState(true);

  useLayoutEffect(() => {
    const delay = setTimeout(() => {
      setDisplay(true);
    }, 800); // starts after the top bar has finished animating

    return () => clearTimeout(delay);
  }, []);

  const pageOne = () => {
    setPageFirst((prev) => !prev);
  };
  const pageTwo = () => {
    setPageSecond((prev) => !prev);
  };
  const pageThree = () => {
    setPageThird((prev) => !prev);
  };
  return (
    <View style={[styles.container, { height: "100vh" }]}>
      <ModuleTop module="esg" active={true} />
      {display &&
        (pageFirst ? (
          <Page1 pageOne={pageOne} {...props} />
        ) : pageSecond ? (
          <Page2 pageTwo={pageTwo} pageThree={pageThree} {...props} />
        ) : pageThird ? (
          <Page4 pageThree={pageThree} pageTwo={pageTwo} {...props} />
        ) : (
          <Page5
            {...props}
            pageOne={pageOne}
            pageTwo={pageTwo}
            pageThree={pageThree}
          />
        ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100vw",
    // backgroundColor: "#eeeeee",
    overflow: "hidden",
  },
});
